import { useQuery } from '@tanstack/react-query';
import { trpc } from '@/utils/trpc';
import type { EfaxOutputDocumentLinkRequest } from '../types';

export const useEfaxOutputDocumentLink = (
  request: EfaxOutputDocumentLinkRequest,
  options?: { enabled?: boolean },
) =>
  useQuery({
    ...trpc.recordUploadRouter.getAnonymousRecordFaxOutputDocumentLink.queryOptions(
      request,
    ),
    enabled: options?.enabled ?? false,
    retry: false,
  });
